import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookie from 'js-cookie'

Vue.use(VueI18n)

import lang_en from '../../translations/trans.en.json'
import lang_es from '../../translations/trans.es.json'

const messages = {
  en: lang_en,
  es: lang_es
};

let locale_cookie = Cookie.get('locale')?Cookie.get('locale'):'en';

Cookie.set('locale', locale_cookie, {expires: 3, sameSite: 'Strict'})

export const i18n = new VueI18n({
  fallbackLocale: 'en',
  locale: locale_cookie, // set locale
  silentTranslationWarn: process.env.NODE_ENV === 'production',
  messages, // set locale messages
});



//////////////////
// WEBPACK FOOTER
// ./src/plugins/i18n.js
// module id = null
// module chunks = 